<template>
  <div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="900px" append-to-body
      @close="handleClose">
      <el-form label-width="100px">
        <el-form-item label="费用清单">
          <el-table :data="feeItems" border show-summary :summary-method="getSummaries" class="fee-table"
            :header-cell-style="{ background: '#edeff4' }">
            <el-table-column label="费用名义" min-width="260">
              <template slot-scope="{ row }">
                <el-input v-model="row.name" placeholder="请输入费用名义" clearable />
              </template>
            </el-table-column>
            <el-table-column label="费用金额" width="200">
              <template slot-scope="{ row }">
                <el-input v-model="row.amount" placeholder="请输入金额" clearable @input="formatAmount(row)">
                  <template slot="append">元</template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150" align="center">
              <template slot-scope="{ $index }">
                <el-button type="success" size="mini" icon="el-icon-plus" @click="addFee"></el-button>
                <el-button type="danger" size="mini" icon="el-icon-minus" :disabled="feeItems.length === 1"
                  @click="removeFee($index)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

        <el-form-item label="附件上传">
          <div class="upload-wrap">
            <el-upload class="charge-uploader" action="#" :show-file-list="false" :http-request="httpup" multiple>
              <el-button type="primary" :loading="uploadLoading">点击上传</el-button>
            </el-upload>
            <div class="file-list" v-if="fileList.length">
              <div class="file-item" v-for="(item, index) in fileList" :key="item.url">
                <a :href="item.url" target="_blank" rel="noopener noreferrer">{{ item.name }}</a>
                <el-button type="text" class="delete-file" @click="removeFile(index)">删除</el-button>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="remark" type="textarea" :rows="3" placeholder="请输入备注" />
        </el-form-item>

        <el-form-item v-if="grid_number" label="已选库位">
          <el-tag type="success">{{ grid_number }}</el-tag>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="dialogVisible = false">{{ $t('message.cancel') }}</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleConfirm">{{ confirmButtonText }}</el-button>
      </span>
    </el-dialog>

    <warehouse v-if="warehouseDialogVisible" :shelf_type_set="warehouseShelfTypes" :type="13" />
  </div>
</template>

<script>
import warehouse from '@/components/common/warehouse.vue'

export default {
  name: 'ShelfToCharge',
  components: {
    warehouse
  },
  data() {
    return {
      dialogVisible: false,
      warehouseDialogVisible: false,
      submitLoading: false,
      uploadLoading: false,
      boxIds: [],
      grid_number: '',
      feeItems: [],
      fileList: [],
      remark: '',
      dialogTitle: '上架到长存仓库',
      submitApiName: 'shelfToCharge',
      warehouseShelfTypes: [4],
      needWarehouse: true
    }
  },
  computed: {
    totalAmount() {
      const total = this.feeItems.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
      return total.toFixed(2).replace(/\.00$/, '')
    },
    confirmButtonText() {
      return this.needWarehouse ? '选择库位' : '确认提交'
    }
  },
  methods: {
    // 打开弹框时重置费用、附件和库位数据
    init(boxIds, options = {}) {
      this.boxIds = [...boxIds]
      this.grid_number = ''
      this.fileList = []
      this.remark = ''
      this.submitLoading = false
      this.uploadLoading = false
      this.warehouseDialogVisible = false
      this.dialogTitle = options.title || '上架到长存仓库'
      this.submitApiName = options.apiName || 'shelfToCharge'
      this.warehouseShelfTypes = options.shelfTypes || [4]
      this.needWarehouse = options.needWarehouse !== false
      this.feeItems = [{ name: '', amount: '' }]
      this.dialogVisible = true
    },
    handleClose() {
      this.warehouseDialogVisible = false
    },
    addFee() {
      this.feeItems.push({ name: '', amount: '' })
    },
    removeFee(index) {
      if (this.feeItems.length === 1) return
      this.feeItems.splice(index, 1)
    },
    formatAmount(item) {
      item.amount = String(item.amount)
        .replace(/[^\d.]/g, '')
        .replace(/^\./, '')
        .replace(/\.{2,}/g, '.')
        .replace('.', '#')
        .replace(/\./g, '')
        .replace('#', '.')
        .replace(/^(\d+)\.(\d{0,2}).*$/, '$1.$2')
    },
    getSummaries() {
      return ['合计', `${this.totalAmount} 元`, '']
    },
    // 使用 footer.vue 同款 OSS 上传，只保存返回链接和原文件名
    async httpup(file) {
      this.uploadLoading = true
      try {
        const res = await this.createClient(file)
        this.fileList.push({
          name: file.file.name,
          url: res.data
        })
      } finally {
        this.uploadLoading = false
      }
    },
    removeFile(index) {
      this.fileList.splice(index, 1)
    },
    getAttachments() {
      return this.fileList.map(item => item.url).filter(Boolean)
    },
    validateForm() {
      if (!this.boxIds.length) {
        this.$message.error(this.$t('message.selectableOperational'))
        return false
      }
      for (let i = 0; i < this.feeItems.length; i++) {
        const item = this.feeItems[i]
        if (!item.name) {
          this.$message.error('请输入费用名义')
          return false
        }
        if (item.amount === '' || Number(item.amount) <= 0) {
          this.$message.error('请输入正确的费用金额')
          return false
        }
      }
      return true
    },
    openWarehouse() {
      if (!this.validateForm()) return
      this.warehouseDialogVisible = true
    },
    handleConfirm() {
      if (!this.validateForm()) return
      if (this.needWarehouse) {
        this.warehouseDialogVisible = true
        return
      }
      this.submit()
    },
    selectChargeGridNumber(gridNumber) {
      this.grid_number = gridNumber
      this.submit()
    },
    submit() {
      if (this.needWarehouse && !this.grid_number) {
        this.$message.error('请选择库位')
        return
      }
      const attachments = this.getAttachments()
      const params = {
        boxIds: this.boxIds,
        fee_items: this.feeItems,
        attachments,
        remark: this.remark
      }
      if (this.needWarehouse) {
        params.grid_number = this.grid_number
      }
      this.submitLoading = true
      this.$api.inventoryTransferApi[this.submitApiName](params).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false
        this.$emit('success')
      }).finally(() => {
        this.submitLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.shelf-charge-form {
  padding: 6px 18px 0 0;
}

.fee-table {
  width: 100%;
}

.total-row {
  margin-top: 10px;
  padding: 8px 12px;
  border: 1px solid #ebeef5;
  border-top: 0;
  background: #fafafa;
  color: #303133;
  font-weight: 700;
  text-align: right;
}

.upload-wrap {
  display: flex;
  align-items: flex-start;
  gap: 18px;
}

.file-list {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 560px;
}

.file-item {
  display: flex;
  align-items: center;
  min-height: 38px;
  padding: 0 10px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  transition: border-color 0.2s, background-color 0.2s;

  &::before {
    content: "\e77d";
    flex: 0 0 auto;
    margin-right: 8px;
    color: #909399;
    font-family: element-icons;
    font-size: 16px;
  }

  &:hover {
    border-color: #409eff;
    background: #f5f9ff;
  }

  a {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    color: #303133;
    text-overflow: ellipsis;
    white-space: nowrap;

    &:hover {
      color: #409eff;
      text-decoration: underline;
    }
  }
}

.delete-file {
  flex: 0 0 auto;
  margin-left: 12px;
  color: #f56c6c;

  &:hover {
    color: #f78989;
  }
}

.tips {
  flex: 1;
  margin-top: 4px;
  line-height: 22px;
}

.charge-uploader /deep/ .el-upload--picture-card,
.charge-uploader /deep/ .el-upload-list__item {
  width: 92px;
  height: 92px;
  line-height: 92px;
}
</style>
